import { useEffect, useState } from "react";
import { getMessages } from "./messages";

import MessageForm from "./MessageForm";
import MessageList from "./MessageList";

export default function MessageDashboard() {
  const [messages, setMessages] = useState([]);

  const load = async () => {
    const data = await getMessages();
    setMessages(data);
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <div>
      <h1>Admin Dashboard</h1>

      <MessageForm onRefresh={load} />

      <MessageList messages={messages} onRefresh={load} />
    </div>
  );
}
